<template>
  <div id="app">
    
    <CheckTouch />
    <Menu ref="menu" />

    <!-- router transition -->
    <transition
      :name="transitionName"
      mode="out-in">
      <router-view
        :key="hardRouterKey"
        :cookieConsent="true"
        @change-step="$_changeStep"
        @open-categories="$_openCategories" />
    </transition>

    <!-- cookies 
    <CookieBar @cookiebar-closed="$_cookieBarOff"/>-->

  </div>
</template>

<script>

import CheckTouch from '@/components/CheckTouch/CheckTouch.vue'
import Menu from '@/components/Menu/Menu'
//import CookieBar from '@/components/CookieBar/CookieBar'
import { mapGetters } from 'vuex'

export default {
  components: {
    Menu,
    //CookieBar,
    CheckTouch
  },
  data: () => ({
    transitionName: 'fade',
    showCartArea: false,
    cookieConsent: false,
    step: 0
  }),
  computed: {
    ...mapGetters([
      'touch'
    ]),
    hardRouterKey: {
      get () {
        /* Al cambio delle categorie, non ci sarebbe un cambio di rotta, ma un cambio di slug. Quindi non verrebbe presa la transition. Mettendo però una variabile, il cambio avviene lo stesso. valore ritornato: es: single-category.it-categoria */
        return this.$route.name + '.' + Object.values(this.$route.params).join('-')
      }
    },
    hardSlug: {
      get () {
        if (this.$route.name.includes('single-product')) return this.$route.params.slug
        return undefined
      }
    }
  },
  methods: {
    $_openCategories () {
      this.$refs.menu.toggleCategories()
    },
    /*$_cookieBarOff () {
      this.cookieConsent = true
    },*/
    $_changeStep (step) {
      console.log(step)
      this.step = step.step
    }
  },
  watch: {
    '$route': {
      handler (to, from) {
        this.$refs.menu.close()
        if (to.name === from.name) this.transitionName = 'fade-slow'
        else this.transitionName = 'fade'
      }
    }
  }
}
</script>


<style lang="scss">
  @import './app.scss';

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }

  .fade-slow-enter-active,
  .fade-slow-leave-active {
    transition-duration: .7s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-slow-enter,
  .fade-slow-leave-active {
    opacity: 0
  }
  
</style>
